import { Component, OnInit } from '@angular/core';
import data from '../../../../assets/service-requests.json';
import { PROGRAM_MENU } from '../../../../treo.properties';
import { ColDef } from '@ag-grid-community/core';
import { LoaderService } from '../../../../app/core/services/loading.service';
import { ProgramService } from '../programs.service';
import { Router } from '@angular/router';
import { GridReadyEvent } from 'ag-grid-community';
import moment from 'moment';

@Component({
    selector: 'app-service-req-page',
    templateUrl: './service-req-page.component.html',
    standalone: false
})
export class ServiceReqPageComponent implements OnInit {
    programSRLinks:any;
    showAddNewWCPRequest: boolean = false;
    serviceRequestLabel = PROGRAM_MENU;
    outstandingData: any;
    outstandingHeader: Object;
    cancelledData: any;
    cancelledHeader: Object;
    completedData: any;
    completedHeader: Object;

    public defaultColDef: ColDef = {
        resizable: false,
        autoHeight: true,
        wrapText: true,
        wrapHeaderText: true
    };
    gridApi1: any;
    paginationPageSizeOutstanding = 10;
    paginationPageSizeSelectorOutstanding: any[];
    totalRowsOutstanding = 0;
    outstandingTableData = [];
    outstandingColumnDefs: ColDef[] = [
        {
            headerName: ' REQUEST NUMBER ',
            field: 'requestNumber',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator ',
            flex: 1,
            cellRenderer: (params) => {
                if (params.data.requestCategory === 'WC Posting Notice') {
                    const link = document.createElement('a');
                    link.style.cursor = 'pointer';
                    link.innerText = params.value;
                    link.addEventListener('click', () => this.redirectToRequest(params.value, 'Outstanding'));
                    return link;
                } else {
                    const span = document.createElement('span');
                    span.innerText = params.value;
                    return span;
                }
                
            }
        },
        {
            headerName: 'DATE REQUESTED ',
            field: 'requestDate',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        },
        {
            headerName: 'TYPE ',
            field: 'requestCategory',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        },
        {
            headerName: 'REQUESTED BY ',
            field: 'requestedBy',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        }
    ];

    gridApi2: any;
    paginationPageSizeCompleted = 10;
    paginationPageSizeSelectorCompleted: any[];
    totalRowsCompleted = 0;
    completedTableData = [];
    completedColumnDefs: ColDef[] = [
        {
            headerName: ' REQUEST NUMBER ',
            field: 'requestNumber',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator ',
            flex: 1,
            cellRenderer: (params) => {
                if (params.data.requestCategory === 'WC Posting Notice') {
                    const link = document.createElement('a');
                    link.style.cursor = 'pointer';
                    link.innerText = params.value;
                    link.addEventListener('click', () => this.redirectToRequest(params.value, 'Completed'));
                    return link;
                } else {
                    const span = document.createElement('span');
                    span.innerText = params.value;
                    return span;
                }
            }
        },
        {
            headerName: 'DATE REQUESTED ',
            field: 'requestDate',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        },
        {
            headerName: 'TYPE ',
            field: 'requestCategory',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        },
        {
            headerName: 'REQUESTED BY ',
            field: 'requestedBy',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        },
        {
            headerName: 'DATE COMPLETED ',
            field: 'completionDate',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        }
    ];

    gridApi3: any;
    paginationPageSizeCancelled = 10;
    paginationPageSizeSelectorCancelled: any[];
    totalRowsCancelled = 0;
    cancelledTableData = [];
    cancelledColumnDefs: ColDef[] = [
        {
            headerName: ' REQUEST NUMBER ',
            field: 'requestNumber',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator ',
            flex: 1,
            cellRenderer: (params) => {
                if (params.data.requestCategory === 'WC Posting Notice') {
                    const link = document.createElement('a');
                    link.style.cursor = 'pointer';
                    link.innerText = params.value;
                    link.addEventListener('click', () => this.redirectToRequest(params.value, 'Cancelled'));
                    return link;
                } else {
                    const span = document.createElement('span');
                    span.innerText = params.value;
                    return span;
                }
                
            }
        },
        {
            headerName: 'DATE REQUESTED ',
            field: 'requestDate',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        },
        {
            headerName: 'TYPE ',
            field: 'requestCategory',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        },
        {
            headerName: 'REQUESTED BY ',
            field: 'requestedBy',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        },
        {
            headerName: 'DATE CANCELLED ',
            field: 'completionDate',
            sortable: false,
            suppressMovable: true,
            lockVisible: true,
            headerClass: 'no-separator custom-header-margin',
            flex: 1
        }
    ];

    constructor(public loaderService: LoaderService, public programsService: ProgramService, private router: Router) {}

    ngOnInit() {
        this.programSRLinks = JSON.parse(this.loaderService.getItem('serviceFunctionsLinks'));
        if (this.programSRLinks['Add New WC Posting Notice Request']) {
            this.showAddNewWCPRequest = true;
        }
        const activeTab = sessionStorage.getItem('activeServiceReqTab');
        console.log('activeTab', activeTab);
        // mark tab active based on updatedStatus
        this.getPageLoadData();
    }

    redirectToRequest(requestNumber: string, type:string) {
        sessionStorage.setItem('clickedServiceReqType', type);
        this.router.navigate(['/program/service-request-detail/' + requestNumber]);
    }

    getPageLoadData() {
        this.loaderService.showLoader();
        const payload = {
            actionType: 'SERVICE_REQUEST',
            operation: 'RETRIEVE_LIST_SR',
            organizationId: this.loaderService.getItem('orgId'),
            applicationAccntDtlId: this.getApplicationId()
        };
        this.programsService.fetchData(payload).subscribe({
            next: (resp: any) => {
                this.loaderService.hideLoader();
                this.formatData(resp);
            },
            error: () => {
                this.loaderService.hideLoader();
            }
        });
    }

    formatData(resp: any) {
        this.formatOutstandingData(resp.serviceRequestVOListOutstanding);
        this.formatCompletedData(resp.serviceRequestVOListCompleted);
        this.formatCancelledData(resp.serviceRequestVOListCancelled);
    }

    formatOutstandingData(data: any) {
        if (data && data.length > 0) {
            this.outstandingTableData = data.map((item: any) => ({
                requestNumber: item.requestNumber,
                requestDate: moment(item.requestDate).utc().format('MM/DD/YYYY'),
                requestCategory: item.requestCategory?.categoryDescription,
                requestedBy: item.requestedBy
            }));
            this.totalRowsOutstanding = this.outstandingTableData.length;
        } else {
            this.outstandingTableData = [];
            this.totalRowsOutstanding = 0;
        }
        this.paginationPageSizeOutstanding = 10;
        this.paginationPageSizeSelectorOutstanding = [];
        this.pageSizeOptionsOS();
    }

    formatCompletedData(data: any) {
        if (data && data.length > 0) {
            this.completedTableData = data.map((item: any) => ({
                requestNumber: item.requestNumber,
                requestDate: item.requestDate ? moment(item.requestDate).utc().format('MM/DD/YYYY') : '',
                requestCategory: item.requestCategory?.categoryDescription,
                requestedBy: item.requestedBy,
                completionDate: item.completionDate ? moment(item.completionDate).utc().format('MM/DD/YYYY') : ''
            }));
            this.totalRowsCompleted = this.completedTableData.length;
        } else {
            this.completedTableData = [];
            this.totalRowsCompleted = 0;
        }
        this.paginationPageSizeCompleted = 10;
        this.paginationPageSizeSelectorCompleted = [];
        this.pageSizeOptionsComp();
    }

    formatCancelledData(data: any) {
        if (data && data.length > 0) {
            this.cancelledTableData = data.map((item: any) => ({
                requestNumber: item.requestNumber,
                requestDate: item.requestDate ? moment(item.requestDate).utc().format('MM/DD/YYYY') : '',
                requestCategory: item.requestCategory?.categoryDescription,
                requestedBy: item.requestedBy,
                completionDate: item.completionDate ? moment(item.completionDate).utc().format('MM/DD/YYYY') : ''
            }));
            this.totalRowsCancelled = this.cancelledTableData.length;
        } else {
            this.cancelledTableData = [];
            this.totalRowsCancelled = 0;
        }
        this.paginationPageSizeCancelled = 10;
        this.paginationPageSizeSelectorCancelled = [];
        this.pageSizeOptionsCancelled();
    }

    onGridReadyOutstanding(params: GridReadyEvent) {
        this.gridApi1 = params.api;
        this.gridApi1.hideOverlay();
    }

    pageSizeOptionsOS() {
        let maxRange = this.totalRowsOutstanding <= 500 ? this.totalRowsOutstanding + 10 : 500;
        maxRange = this.checkMaxRange(maxRange);
        for (let i = 10; i <= maxRange; i += 10) {
            this.paginationPageSizeSelectorOutstanding.push(i);
        }
    }

    onGridReadyCompleted(params: GridReadyEvent) {
        this.gridApi2 = params.api;
        this.gridApi2.hideOverlay();
    }

    pageSizeOptionsComp() {
        let maxRange = this.totalRowsCompleted <= 500 ? this.totalRowsCompleted + 10 : 500;
        maxRange = this.checkMaxRange(maxRange);
        for (let i = 10; i <= maxRange; i += 10) {
            this.paginationPageSizeSelectorCompleted.push(i);
        }
    }

    onGridReadyCancelled(params: GridReadyEvent) {
        this.gridApi3 = params.api;
        this.gridApi3.hideOverlay();
    }

    pageSizeOptionsCancelled() {
        let maxRange = this.totalRowsCancelled <= 500 ? this.totalRowsCancelled + 10 : 500;
        maxRange = this.checkMaxRange(maxRange);
        for (let i = 10; i <= maxRange; i += 10) {
            this.paginationPageSizeSelectorCancelled.push(i);
        }
    }

    checkMaxRange(maxRange?: number) {
        if (maxRange % 10 === 0 && maxRange != 500) {
            maxRange = maxRange - 10;
        }
        return maxRange;
    }

     getApplicationId() {
        const encodedId = this.loaderService.getItem('appAccountDetailId');
        if (!encodedId) return null;

        const decodedId = encodedId;
        return Number(decodedId) === 0 ? null : decodedId;
    }
}
